import { ClientBusinessModel } from 'app/client/clientBusiness/models/ClientBusiness';
import { RateModel } from 'app/client/clientBusiness/rates/models/RateModel';
import moment, { Moment } from 'moment';
import {
  transferReservationBaseFormBuilder,
  TransferReservationBaseFormType,
  transferReservationBaseLocationFormBuilder,
  TransferReservationBaseLocationFormType
} from '../../viajeTraslado/forms/base/TransferReservationBaseFormTypes';
import {
  ReservaTrasladoRepetitiveCreateModel,
  TransferReservationRepetitiveModel
} from '../models/TransferreservationRepetitiveModel';

export interface TransferReservationRepetitiveFormType
  extends TransferReservationBaseFormType {
  prioridad: boolean;
  tipoServicio: string;
  fixedRate: RateModel['categories'][0]['fixedPrices'][0] | null;
  hasOutSite: boolean;
  bus_provider_price?: number;
  bus_customer_price?: number;
  bus_is_outsourced?: boolean;
  bus_observation?: string;
  bus_type_id?: number;
  bus_vehicle_id?: number;
  fechaYHoraDeLlegada: Moment;
  minutosPreviosASalida: Moment;
  puntos: TransferReservationBaseLocationFormType[];
  repeatOnMonday: boolean;
  repeatOnTuesday: boolean;
  repeatOnWednesday: boolean;
  repeatOnThursday: boolean;
  repeatOnFriday: boolean;
  repeatOnSaturday: boolean;
  repeatOnSunday: boolean;
  repetitionFinishDate: Moment;
  repetitionInitDate: Moment;
  isEvent: boolean;
  nameEvent: string;
  customerPrice: number;
  providerPrice: number;
  isLLTPais: boolean;
}

function reservaTrasladoRepetitiveFormToModel(
  form: TransferReservationRepetitiveFormType
): ReservaTrasladoRepetitiveCreateModel {
  return {
    ...transferReservationBaseFormBuilder.toModel(form),
    prioridad: form.prioridad,
    tipoServicio: form.tipoServicio,
    fixedRate: form.fixedRate,
    hasOutSite: form.hasOutSite,
    bus_requirement: {
      provider_price: form.bus_provider_price || 0,
      customer_price: form.bus_customer_price || 0,
      is_outsourced: form.bus_is_outsourced || false,
      observation: form.bus_observation || '',
      bus_type_id: form.bus_type_id || 0,
      vehicle_id: form.bus_vehicle_id || undefined
    },
    fechaYHoraDeLlegada: form.fechaYHoraDeLlegada,
    fechaYHoraDeSalida: form.minutosPreviosASalida,
    puntos: form.puntos.map(transferReservationBaseLocationFormBuilder.toModel),
    repeatOnMonday: form.repeatOnMonday,
    repeatOnTuesday: form.repeatOnTuesday,
    repeatOnWednesday: form.repeatOnWednesday,
    repeatOnThursday: form.repeatOnThursday,
    repeatOnFriday: form.repeatOnFriday,
    repeatOnSaturday: form.repeatOnSaturday,
    repeatOnSunday: form.repeatOnSunday,
    repetitionFinishDate: form.repetitionFinishDate,
    repetitionInitDate: form.repetitionInitDate
  };
}

function reservaRepetitiveModelToForm(
  reserva: TransferReservationRepetitiveModel,
  cliente: ClientBusinessModel,
  fixedRate: RateModel['categories'][0]['fixedPrices'][0] | null
): TransferReservationRepetitiveFormType {
  return {
    cliente,
    solicitante: reserva.requirements.applicant!,
    autorizado: reserva.requirements.authorized ?? null,
    costCenter: reserva.requirements.costCenter ?? '',
    subCostCenter: reserva.requirements.subCostCenter ?? '',
    sector: reserva.requirements.sector ?? '',
    buyOrder: reserva.requirements.buyOrder ?? '',
    employeeNumber: reserva.requirements.employeeNumber ?? '',
    platformApplication: reserva.requirements.platformApplication ?? '',
    tripNumber: reserva.requirements.tripNumber ?? '',
    canalIngreso: reserva.entry_channel ?? '',
    plataformaId: reserva.platform_id ? String(reserva.platform_id) : '',
    prioridad: reserva.has_priority,
    tipoServicio: reserva.service_type,
    observacionCoordinacion: reserva.coordination_observation ?? '',
    fixedRate,
    hasOutSite: reserva.has_out_site,
    data1: reserva.requirements.data1,
    data2: reserva.requirements.data2,
    data3: reserva.requirements.data3,
    fechaYHoraDeLlegada: moment()
      .hours(reserva.reservation_hours)
      .minutes(reserva.reservation_minutes),
    minutosPreviosASalida: moment()
      .hours(reserva.reservation_hours)
      .minutes(reserva.reservation_minutes)
      .add(-reserva.advance_hours, 'hours'),
    puntos: reserva.puntos.map((p) => ({
      domicilio: p.domicilio,
      espera: p.minutosEspera ? String(p.minutosEspera) : '0',
      observacion: p.observacion ?? '',
      pasajeros: p.pasajeros
    })),
    repeatOnMonday: reserva.monday,
    repeatOnTuesday: reserva.tuesday,
    repeatOnWednesday: reserva.wednesday,
    repeatOnThursday: reserva.thursday,
    repeatOnFriday: reserva.friday,
    repeatOnSaturday: reserva.saturday,
    repeatOnSunday: reserva.sunday,
    repetitionFinishDate: reserva.to_date,
    repetitionInitDate: reserva.from_date,
    pay_with_cash: reserva.pay_with_cash,
    isEvent: reserva.is_event,
    nameEvent: reserva.name_event ?? '',
    isLLTPais: reserva.isLLTPais ? true : false,
    customerPrice: reserva?.customer_price || 0,
    providerPrice: reserva?.provider_price || 0,
    bus_customer_price: reserva?.bus_requirement?.customer_price || 0,
    bus_provider_price: reserva?.bus_requirement?.provider_price || 0,
    bus_is_outsourced: reserva?.bus_requirement?.is_outsourced || false,
    bus_observation: reserva?.bus_requirement?.observation || '',
    bus_type_id: reserva?.bus_requirement?.bus_type_id || 0,
    bus_vehicle_id: reserva?.bus_requirement?.vehicle_id || 0,
  };
}

export const transferReservationRepetitiveFormBuilder = {
  toModel: reservaTrasladoRepetitiveFormToModel,
  toForm: reservaRepetitiveModelToForm
};
